export default "__VITE_ASSET__yA_DQkRx__"